import React from 'react';
import { HeroSection } from './HeroSection';
import { WhoThisIsFor } from './WhoThisIsFor';
import { BedtimeDread } from './BedtimeDread';
import { WhyAdviceFails } from './WhyAdviceFails';
import { StabilizationLadder } from './StabilizationLadder';
import { WhatYouGet } from './WhatYouGet';
import { BonusSection } from './BonusSection';
import { WhatChanges } from './WhatChanges';
import { QuietPromise } from './QuietPromise';
import { FAQSection } from './FAQSection';
import { CTASection } from './CTASection';
import { Footer } from './Footer';
import { FloatingCTA } from './FloatingCTA';
export function SalesPage({
  onNavigate
}: {
  onNavigate: (page: 'terms' | 'privacy') => void;
}) {
  return <div className="min-h-screen bg-white font-sans text-text-body" data-id="element-358">
      <HeroSection data-id="element-359" />
      <WhoThisIsFor data-id="element-360" />
      <BedtimeDread data-id="element-361" />
      <WhyAdviceFails data-id="element-362" />
      <StabilizationLadder data-id="element-363" />
      <WhatYouGet data-id="element-364" />
      <BonusSection data-id="element-365" />
      <WhatChanges data-id="element-366" />
      <QuietPromise data-id="element-367" />
      <FAQSection data-id="element-368" />
      <CTASection data-id="element-369" />
      <Footer onNavigate={onNavigate} data-id="element-370" />
      <FloatingCTA data-id="element-371" />
    </div>;
}